import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider  } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";   

const firebaseConfig = {
  apiKey: "AIzaSyBSM-PqPSSYa9P7tNpxPLNmR0RO_Efi9nw",
  authDomain: "seta-4ce28.firebaseapp.com",
  projectId: "seta-4ce28",
  storageBucket: "seta-4ce28.firebasestorage.app",
  messagingSenderId: "555028656466",
  appId: "1:555028656466:web:554adbaa3f188b31000a8b",
  measurementId: "G-4K7YG74LHE"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const storage = getStorage(app);
const db = getFirestore(app);

export { auth, provider, db,storage  };
